// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { create } from 'zustand'

interface AuthState {
  userId:          string | null
  isAuthenticated: boolean
  isLoading:       boolean
  lastLoginAt:     string | null

  // Actions
  setAuthenticated: (userId: string) => void
  clearAuth:        () => void
  setLoading:       (loading: boolean) => void
}

export const useAuthStore = create<AuthState>((set) => ({
  userId:          null,
  isAuthenticated: false,
  isLoading:       false,
  lastLoginAt:     null,

  setAuthenticated: (userId) =>
    set({
      userId,
      isAuthenticated: true,
      isLoading:       false,
      lastLoginAt:     new Date().toISOString(),
    }),

  clearAuth: () =>
    set({
      userId:          null,
      isAuthenticated: false,
      isLoading:       false,
    }),

  setLoading: (loading) =>
    set({ isLoading: loading }),
}))
